{
    "runtime": {
        "commandFrameMs": 250,
        "physicsSubstepMs": 50,
        "preloadSyncTimeoutMs": 180000,
        "matchReadySyncTimeoutMs": 240000,
        "navCollClampsToNavMesh": true,
        "navMeshHoleOffsetPx": 15
    },
    "presentation": {
        "tileRevealStagger": {
            "seedPadBurstEnabled": true,
            "grassBurstEnabled": true,
            "flowerWaveEnabled": true,
            "progressCounterSync": true,
            "stepMs": 50
        },
        "obstacleGrowth": {
            "leadInMs": 750,
            "letterboxCloseMs": 500,
            "letterboxOpenMs": 500,
            "jitterLowPx": 2,
            "jitterGrowthPx": 4,
            "artStaggerMsMax": 500,
            "artMarginTilesLateral": 1,
            "artMarginTilesSouth": 2,
            "letterboxZoomIn": 0.15
        },
        "obstructionProximityFade": {
            "enabled": true,
            "radiusTiles": 4,
            "centerAlpha": 0.15,
            "applyForAllyBots": false,
            "stages": ["tree"]
        },
        "obstructionGrassSolidMinStage": "tree",
        "grassAimPreviewDelayMs": 200,
        "localPlayerBot": {
            "showDirectionRing": false
        }
    },
    "tileVisibilityThreshold": 0.5,
    "tileVisibilitySampleDensity": 5,
    "seedPadBurstsUseTileVisibility": false
}
